import { Token } from 'entities/Token';

import { emptyAddress } from 'contracts/addresses';

export const checkAuctionInProgress = (data: Token | null) => {
  const bidder = data?.bidderAddress;
  const isClaim = data?.status === 'nonClaimed';
  const isTimer = data?.timer;
  return bidder !== '' && bidder !== emptyAddress && !isClaim && Boolean(isTimer);
};

export const checkAuctionEnd = (data: Token | null, address: string, accUsername: string | null | undefined) => {
  const isListed = data?.price !== 0;
  const isFinalized = data?.status === 'nonClaimed';

  const bidder = data?.bidderAddress;
  const owner = data?.owner?.nickName;

  const isMyToken = address === bidder || accUsername === owner;

  return isMyToken && isListed && isFinalized;
};

export const checkTypeCard = (data: Token | null, address: string, accUsername: string | null | undefined) => {
  const isMinted = data?.status === 'minted' || data?.status === 'purchased';
  const isSold = data?.isSold;
  const isCollection = data?.collection;
  const isFinalized = data?.status === 'nonClaimed';

  let isMyToken = false;

  const ownedMi = data?.owners?.find((o) => o.wallet === address);
  if (ownedMi) {
    isMyToken = true;
  }

  const isFullOnSaleCollection = data?.onSaleAmountOfCopies === data?.amountOfCopies;
  let isListed = data?.status === 'reservePrice';
  if (data?.collection && data?.sellers?.length && ownedMi) {
    const sellerMy = data?.sellers?.find((u) => u.seller.id === ownedMi?.id);
    isListed = !!sellerMy;
  }

  const isCelebrity = data?.owner?.role === 'celebrity';
  const isStaked = data?.staking?.onStake;

  const isWhitelist = data?.status === 'notconfirmed';
  const isWhitelisted = data?.status === 'active';

  const auctionInProgress = checkAuctionInProgress(data);
  const auctionEnd = checkAuctionEnd(data, address, accUsername);

  let type = isCollection ? 'collection' : 'preview';

  if (!isCollection) {
    if (auctionInProgress) {
      type = 'auction';
    }

    if (auctionEnd) {
      type = 'auctionEnd';
    }

    if (!isMyToken && isFinalized) {
      type = 'sold';
    }

    if (isMyToken && isSold && !isCelebrity && !auctionEnd) {
      type = 'list';
    }

    if (!isListed && isMyToken && isMinted) {
      type = 'mint';
      if (isStaked) {
        type = 'staked';
      }
    }

    if (!auctionEnd && !auctionInProgress && !isFinalized && isListed) {
      type = 'reserve';
    }

    if (isWhitelist) {
      type = 'whitelist';
    }
    if (isWhitelisted) {
      type = 'whitelisted';
      if (isStaked) {
        type = 'stakedNonPlatform';
      }
    }
  }

  if (isCollection) {
    if (isMyToken && isListed) {
      type = 'list';
    }

    if (isMyToken && !isListed) {
      type = 'mint';
    }

    if (isFullOnSaleCollection) {
      type = 'collection';
    }

    if (!isMyToken && isListed && isFullOnSaleCollection) {
      type = 'collection';
    }
  }

  return type;
};

export const blockChainCurrency = (blockchain: string) => {
  switch (blockchain.toLowerCase()) {
    case 'eth':
      return 'ETH';
    case 'bsc':
      return 'BNB';
    case 'polygon':
      return 'MATIC';
    case 'whitebit':
      return 'WBT';
    default:
      return null;
  }
};
